import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { LocationService } from '../../../services/location.service';
import { CategoryService } from '../../../services/category.service';


@Component({
  selector: 'app-category-picker',
  templateUrl: './category-picker.component.html',
  styleUrls: ['./category-picker.component.scss']
})
export class CategoryPickerComponent implements OnInit, OnChanges {
  @Input() categoryId: number;
  @Input() _placeholder: string = 'Please Select';
  @Output() onCategoryIdSet = new EventEmitter<number>();
  @Output() onCategorySet = new EventEmitter<any>();
  defaultPlaceholder: string;
  categories = [];


  constructor(public categoryService: CategoryService) {
  }

  ngOnInit(): void {
    
    this.defaultPlaceholder = this._placeholder;

    this.categoryService.getAll().then((categories) => {
      this.categories = categories;

      if (this.categoryId != undefined && this.categoryId != null) {
        var location = this.categories.find(a => a.id == this.categoryId);
        if (location != null) {
          this._placeholder = location.name;

        } else {
          this._placeholder = this.defaultPlaceholder;
        }
      }

    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.categoryId != null && changes.categoryId.currentValue != null)) {

      if ((this.categoryId != undefined && this.categoryId != undefined) && (this.categories != undefined && this.categories != undefined)) {
        var location = this.categories.find(a => a.id == this.categoryId);
        if (location != null) {
          this._placeholder = location.name;

        } else {
          this._placeholder = this.defaultPlaceholder;
        }

      }

    } else {
      this._placeholder = this.defaultPlaceholder;
    }
  }

  onChanged(category) {
    if (category) {
      this.onCategoryIdSet.emit(category.id);
      this.onCategorySet.emit(category);
    } else{
      this._placeholder =this.defaultPlaceholder ;
    }

  }

}
